import { Stack } from "@mui/material";
import { HypeIcon } from "../HypeIcon";
import { useMobileBreakpoint } from "@ob/theme";
import { useChatBotScript } from "./useChatBotScript";

export const ChatBot = ({ hideOnMobile }: { hideOnMobile: boolean }) => {
  const { startChat } = useChatBotScript();
  const { isMobile } = useMobileBreakpoint();

  if (hideOnMobile && isMobile) {
    return null;
  }

  return (
    <Stack
      className="hype-chat-bot"
      sx={{
        alignSelf: "end",
        position: "sticky",
        width: "50px",
        height: "50px",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: 2,
        borderRadius: "50%",
        backgroundColor: "common.white",
        cursor: "pointer",
        bottom: 24,
        right: 24,
      }}
      onClick={startChat}
    >
      <HypeIcon name="Chat7" size={22} color="primary.main" aria-label="Chat" />
    </Stack>
  );
};
